import React from 'react';
import PropTypes from 'prop-types';

const NotificationBanner = ({ status, textColor, text }) => {
    let circleColor, bgColor;

    switch (status) {
        case 'NEW':
            circleColor = 'se-bg-[#EEC319]';
            bgColor = 'se-bg-[#FFF6D2]';
            break;
        case 'PICKED_UP':
            circleColor = 'se-bg-[#EEC31A]';
            bgColor = 'se-bg-[#FFF6D2]';
            break;
        case 'OUT_FOR_DELIVERY':
            circleColor = 'se-bg-[#328616]';
            bgColor = 'se-bg-[#EEFFE9]';
            break;
        default:
            circleColor = 'se-bg-gray-500';
            bgColor = 'se-bg-gray-200';
    }

    return (
        <div className={`${bgColor} se-min-w-full se-w-fit se-h-[35px] se-p-4 se-flex se-items-center se-rounded-lg`}>
            <div className={`${circleColor} se-h-[10px] se-w-[10px] se-rounded-full se-mr-2`}></div>
            <span className={`${textColor} se-text-[12px]`}>{text}</span>
        </div>
    );
};

NotificationBanner.propTypes = {
    status: PropTypes.string.isRequired,       // The status to determine colors
    textColor: PropTypes.string.isRequired,    // The color of the text
    text: PropTypes.string.isRequired,         // The text to display
};

export default NotificationBanner;